'use strict';

/**
* @class
* @extends Error
*/
class APIError extends Error {

  /**
   *
   * @param {string} message
   * @param {number} statusCode
   */
  constructor(message, statusCode) {
    super(message || 'Unknown API Error');

    /**
     * Error message
     * @var {string} APIError#message
     */

    /**
     * HTTP Status Code
     * @type {number}
     */
    this.statusCode = statusCode;
  }

}

module.exports = APIError;
